import React, { Component } from "react";
import {
  Card,
  CardBody,
  Button,
  ModalHeader,
  ModalBody,
  Modal,
  ModalFooter
} from "reactstrap";

import { Resources } from "../redux/campaignRedux";

function downloadObjectAsJson(exportObj, exportName) {
  const dataStr = `data:text/json;charset=utf-8,${encodeURIComponent(
    JSON.stringify(exportObj)
  )}`;
  const downloadAnchorNode = document.createElement("a");
  downloadAnchorNode.setAttribute("href", dataStr);
  downloadAnchorNode.setAttribute("download", `${exportName}.json`);
  document.body.appendChild(downloadAnchorNode); // required for firefox
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
}

export default class DownloadCampaignForUSB extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getContentFromServer = async () => {
    const result = await this.props.Get(
      Resources.getCampaignZIP(this.props.id)
    );
    if (result.status === 200) {
      const url = result.data._jsonapi.data.contents_s3_url;
      window.open(url);
    }
  };

  render() {
    return (
      <Modal
        isOpen={this.props.downloadModal}
        className={this.props.className}
        toggle={this.props.downloadForUSB}
      >
        <ModalHeader
          toggle={this.props.downloadForUSB}
        >{`Campaign Name: ${this.props.campaignName}`}</ModalHeader>
        <ModalBody>
          <div className="downloadCampaign">
            <h4>To download campaign data:</h4>
            <ul>
              <li>1. Download campaign contents from the button below.</li>
              <li>2. Extract the contents in your local hard drive.</li>
              <li>
                3. Transfer <code>all files</code> to root of USB device.
              </li>
            </ul>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            className="bx-dots-verticalbtn btn-outline-primary"
            type="button"
            onClick={this.props.downloadForUSB}
          >
            Cancel
          </button>
          <button
            onClick={this.getContentFromServer}
            className="mt-0 primaryButton"
            type="button"
          >
            Download
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}
